import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '@/App';

const API_URL = window.__BACKEND_URL;

export const BrandContext = createContext();

export function BrandProvider({ children }) {
  const { user } = useContext(AuthContext);
  const [brands, setBrands] = useState([]);
  const [activeBrand, setActiveBrand] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      loadBrands();
    }
  }, [user]);

  const loadBrands = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/api/brands`,
        { withCredentials: true }
      );
      setBrands(response.data);
      
      // Load active brand from localStorage or use first brand
      const savedBrandId = localStorage.getItem('active_brand_id');
      if (savedBrandId) {
        const brand = response.data.find(b => b.id === savedBrandId);
        if (brand) {
          setActiveBrand(brand);
        } else if (response.data.length > 0) {
          setActiveBrand(response.data[0]);
          localStorage.setItem('active_brand_id', response.data[0].id);
        }
      } else if (response.data.length > 0) {
        setActiveBrand(response.data[0]);
        localStorage.setItem('active_brand_id', response.data[0].id);
      }
    } catch (err) {
      console.error('Error loading brands:', err);
    } finally {
      setLoading(false);
    }
  };

  const switchBrand = (brand) => {
    setActiveBrand(brand);
    localStorage.setItem('active_brand_id', brand.id);
  };

  return (
    <BrandContext.Provider value={{ brands, activeBrand, switchBrand, loading, refreshBrands: loadBrands }}>
      {children}
    </BrandContext.Provider>
  );
}
